import type { FC, ReactNode } from "react";
import { useMediaQuery } from "react-responsive";

import classNames from "classnames";

import "./Hero.scss";

export type BannerContainerType = {
  bottomMobileImg?: string;
  headerContent: ReactNode;
  loggedTitle: ReactNode;
  unloggedTitle: ReactNode;
  loggedContent: ReactNode;
  unloggedContent: ReactNode;
  isLogged: boolean;
  fullscreen: boolean;
  className?: string;
};

export const BannerContainer: FC<BannerContainerType> = ({
  bottomMobileImg,
  fullscreen,
  headerContent,
  isLogged,
  loggedTitle,
  unloggedTitle,
  loggedContent,
  unloggedContent,
  className,
}: BannerContainerType) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const mobileBottomBackgroundStyle: React.CSSProperties =
    isMobile && !!bottomMobileImg ? { backgroundImage: `url(${bottomMobileImg})` } : {};
  const bannerContainerClass = classNames("hero__container", className, {
    "hero__container--logged": isLogged,
    "hero__container--not-fullscreen": !fullscreen,
  });
  return (
    <div className={bannerContainerClass} data-testid="hero__background-container" style={mobileBottomBackgroundStyle}>
      <div className="hero__header">{headerContent}</div>
      <div className="hero__title">{isLogged ? loggedTitle : unloggedTitle}</div>
      <div className="hero__content">{isLogged ? loggedContent : unloggedContent}</div>
    </div>
  );
};
